import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#each this.textParts as |part|}}\n  <span class={{or-else @blockClassName \"u-d-block\"}}>\n    {{part}}\n  </span>\n{{/each}}")